import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

import EditProfileVisibility from '../edit/EditProfileVisibility';
import { DialogContent, DialogTitle } from '@mui/material';
import DialogBase from './DialogBase';

class DialogEditProfileVisibility extends React.Component {

  render () {
    const { classes, open, onClose, ...others } = this.props;
    const scrollableTargetId = "dialog-edit-profile-visibility";
    return (
      <DialogBase
        open={open}
        onClose={onClose}
      >
        <DialogTitle>Confidentialité</DialogTitle>
        <DialogContent classes={{root: classes.dialogContent}} id={scrollableTargetId}>
          <EditProfileVisibility
            scrollableTarget={scrollableTargetId}
            {...others}
          />
        </DialogContent>
      </DialogBase>
    )
  }
}

const styles = theme => ({
  dialogContent: {
    padding: theme.spacing(0),
  },
});

DialogEditProfileVisibility.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(DialogEditProfileVisibility);
